module.exports = __webpack_public_path__ + "static/media/administrator-icon.871db92a.svg";